module.exports = __webpack_public_path__ + "static/media/why_banner.395395b3.png";